<div class="chat-container" [ngClass]="{'open': isOpen}">
    <div class="header">
        <h3>{{ 'chat.title' | t }}</h3>
    </div>
    <div class="chat">
        <div class="row">
            <div *ngFor="let message of messages" class="col-12" >
                <div class="message" [ngClass]="{'main': message.tipoMensaje === 2, 'waiting': message.tipoMensaje === 3 }">
                    <p>{{ message.translationKey ? (message.translationKey | t) : message.mensaje }}</p>

                    <div class="texto-animado" *ngIf="message.tipoMensaje === 3">
                        <span class="puntos">...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="send">
        <div class="row">
            <div class="col-md-12">
                <div class="input-group mb-3">
                    <input style="outline: none;" type="text" class="form-control" [placeholder]="'chat.placeholder' | t"
                        [attr.aria-label]="'chat.placeholder' | t" aria-describedby="button-addon2" [(ngModel)]="message">
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="addMessage()"
                        *ngIf="message.length > 3" [attr.aria-label]="'chat.send' | t">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-send-fill" viewBox="0 0 16 16">
                            <path
                                d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<button class="btn btn-primary chat-button" (click)="toggleChat()" [attr.aria-label]="'chat.open' | t">
    <i class="fa fa-comment"></i>
</button>
